// extracted by mini-css-extract-plugin
export default {"fp_page":"ForgotPassword_fp_page__u4R2M","fp_card":"ForgotPassword_fp_card__denNn"};